// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'babel-polyfill'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import 'vue-awesome/icons/arrow-right'
import 'vue-awesome/icons/arrow-left'
import 'vue-awesome/icons/angle-left'
import 'vue-awesome/icons/angle-right'
import 'vue-awesome/icons/bars'
import 'vue-awesome/icons/bolt'
import 'vue-awesome/icons/book'
import 'vue-awesome/icons/cog'
import 'vue-awesome/icons/comments'
import 'vue-awesome/icons/eye-slash'
import 'vue-awesome/icons/question'
import 'vue-awesome/icons/pen'
// import 'vue-awesome/icons/shield'
import 'vue-awesome/icons/thumbs-up'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/trash'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/users'
import 'vue-awesome/icons/user-shield'
import 'vue-awesome/icons/regular/lightbulb'
import 'vue-awesome/icons/regular/smile'
import 'vue-awesome/icons/regular/heart'
import 'vue-awesome/icons/regular/thumbs-up'
import 'vue-awesome/icons/caret-up'
import 'vue-awesome/icons/caret-down'
import 'vue-awesome/icons/minus'
import Icon from 'vue-awesome/components/Icon'
import Vue from 'vue'
import Vue2TouchEvents from 'vue2-touch-events'
import VueAxios from 'vue-axios'
import VueLocalStorage from 'vue-localstorage'
import VueProgressBar from 'vue-progressbar'
import VueScrollTo from 'vue-scrollto'
import { VueReCaptcha } from 'vue-recaptcha-v3'

import App from './App'
import router from './router'
import store from './store/'
import i18n from './i18n'
import './registerServiceWorker'

Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL
Vue.axios.defaults.xsrfCookieName = 'XSRF-TOKEN'
Vue.axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'

let reqId = null
Vue.axios.interceptors.response.use(function (response) {
  if (reqId === null && response.headers['x-request-id']) {
    reqId = response.headers['x-request-id']
  }
  return response
}, function (error) {
  return Promise.reject(error)
})

Vue.axios.interceptors.request.use(function (config) {
  if (reqId !== null) {
    config.headers['X-Request-Id'] = reqId
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

Vue.use(VueScrollTo)
Vue.use(Vue2TouchEvents)

const progressBarOptions = {
  color: '#2ab8de',
  failedColor: '#874b4b',
  thickness: '3px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}

Vue.use(VueProgressBar, progressBarOptions)

Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY, loaderOptions: { useRecaptchaNet: false, autoHideBadge: true } })

Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})

Vue.config.productionTip = false

Vue.use(VueLocalStorage)

const moment = require('moment')

Vue.use(require('vue-moment'), {
  moment
})

Vue.use(BootstrapVue)

Vue.component('icon', Icon)

// Vue.config.errorHandler = function (err, vm, info) {
//   window.rg4js('send', {
//     error: err,
//     customData: [{ info: info }]
//   })
// }

// SPA pageview tracking rg4js('trackEvent', { type: 'pageView', path: foo });

/* eslint-disable no-new */
const app = new Vue({
  // el: '#app',
  router,
  i18n,
  store,
  template: '<App/>',
  components: { App },
  data () {
    return {
      language: 'en'
    }
  },
  created: function () {
    store.dispatch('preloadState')
  },
  mounted () {
    //
  }
}).$mount('#app')

i18n.i18next.on('languageChanged', function (language) {
  app.$moment.locale(language)
  store.dispatch('updatePreferredLanguage', language)
})

Vue.axios.interceptors.request.use(config => {
  app.$Progress.start() // for every request start the progress
  return config
})

Vue.axios.interceptors.response.use(response => {
  app.$Progress.finish() // finish when a response is received
  return response
})

// Vue.use(VueAnalytics, {
//   id: process.env.VUE_APP_GA_TRACKING_ID,
//   autoTracking: {
//     exception: true,
//     exceptionLogs: true,
//     // screenview: true,
//     page: true
//   },
//   router
// })
